/**
 * 商家档案 · 区块常量
 * ------------------------------------------------------------------
 * 2026-09-17 S2 去嵌套后的结构：
 *   · 商家信息 / 商家洞察 / 资金与结算 → **锚点**（同一商家的多段信息）
 *   · 服务资料 → 四个**不同数据集**（指导课课表 / 课程 / 会话记录 / 专属计划）
 *     → 保留 Tab，但**拉平到同层**（原先藏在 SubNav 的嵌套下拉里，才是真正的"三层"）
 *
 * 锚点列表与 DOM id 的唯一来源：容器与 section 都从这里取，
 * 避免两处手写导致「点了锚点跳不到」。
 */
export const PROFILE_ITEMS = [
  { key: 'info', label: '商家信息' },
  /* 商家洞察（原 POWER 总结）紧跟商家信息（与商家信息同级），不再藏在「服务资料」的三级下拉里 */
  { key: 'power', label: '商家洞察' },
  { key: 'fund', label: '资金与结算' },
  { key: 'service', label: '服务资料' },
];

/** 锚点 section 的 DOM id：由 key 统一生成 */
export const sidOf = (key) => `profile-${key}`;

/**
 * 内嵌的既有业务组件（merchantInfo / lessonPlan / depositRecords /
 * expenditureDetail）自身不带外边距，卡片 body 不能 padding:0，
 * 否则文字直接贴到卡片边缘（图5 反馈的边距问题）。
 */
export const cardPad = { padding: '16px 20px 20px' };
